import { BlaestProduct } from "@/formatters/types";

export const formatBreadcrumbs = ({
  categoryUri,
  categoryName,
  uri,
  name,
}: BlaestProduct) => {
  const categoryUriArr = categoryUri?.split("/");
  const breadcrumbs =
    categoryName?.map((_, i) => ({
      name: (categoryName && categoryName[i]) || "",
      uri: categoryUriArr?.slice(0, i + 1).join("/"),
    })) ?? [];

  if (uri && name) {
    breadcrumbs?.push({ name: name, uri: uri });
  }

  return breadcrumbs;
};
